"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import type { default as React } from "react";
import { Balancer } from "react-wrap-balancer";

import { cn } from "@trip/utils";

const RadioGroup = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
  ref?: React.Ref<React.ComponentRef<typeof RadioGroupPrimitive.Root>>;
}) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn(
        "grid rounded-lg border border-neutral-200 bg-neutral-200/50",
        className,
      )}
      {...props}
      ref={ref}
    />
  );
};
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = ({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  ref?: React.Ref<React.ComponentRef<typeof RadioGroupPrimitive.Item>>;
}) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aria-checked:text-primary hover:text-primary focus:outline-hidden focus-visible:ring-ring relative rounded-lg border border-transparent px-2 py-1.5 text-neutral-500 focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50 aria-checked:bg-white",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="border-primary/10 absolute -inset-0.5 rounded-lg border-[0.5px] shadow-sm" />
      <Balancer>{children}</Balancer>
    </RadioGroupPrimitive.Item>
  );
};
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
